export default "__VITE_ASSET__sRdz3iSu__"